<template lang="html">
  <span>Dashboard help</span>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>
